//////////////////////////////////////////////////////////   
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO BOTÃO DE LOGIN EM TODOS OS             //   
//  HEADERS PORÉM SÓ QUANDO O USUÁRIO NÃO ESTÁ LOGADO   //   
//                                                      //   
//  FUNCIONALIDADE: REDIRECIONAR PARA A PAGINA          //   
//    DE LOGIN E DE CRIAR USUÁRIO                       //    
//                                                      //   
//////////////////////////////////////////////////////////   



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/continuar_comprando.js                  //
//      frontend/src/components/header.js                               //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../../assets/css/local/header.css';

function LoginButton() {
    async function login(){  // FUNÇÃO PARA REDIRECIONAR PARA A PÁGINA DE LOGIN
        // FUNÇÃO CHAMADA NO CLICK DO BOTAO DE LOGIN DESTE COMPONENTE

        window.location.href = '/login'
    }

    if(sessionStorage['login']){  // CASO O USUÁRIO ESTEJA LOGADO, O COMPONENTE NÃO APARECE POR ESTAR COM A CLASSE 'd-none'
        return (
            <div className="d-none col-2" id='login_btn'>
                <div className="d-none d-lg-block header-size">
                    <button className="btn-pretobranco my-1 pull-right px-2 montserrat" onClick={login}>
                        <i className="fa fa-user-circle mr-4"></i>
                        Login
                    </button>
                </div>
                <div className="d-lg-none header-size">
                    <button className="login-pqn my-1 pull-right" onClick={login}>
                        <i className="fa fa-user-circle"></i>
                    </button>
                </div>
            </div>
        );
    }
    else{     // CASO O USUÁRIO NÃO ESTEJA LOGADO, O COMPONENTE É RENDERIZADO NORMALMENTE
        return (
            <div className="col-2" id='login_btn'>
                <div className="d-none d-lg-block header-size">
                    <button className="btn-pretobranco my-1 pull-right px-2 montserrat" onClick={login}>
                        <i className="fa fa-user-circle mr-4"></i>
                        Login
                    </button>
                </div>
                <div className="d-lg-none header-size">
                    <button className="login-pqn my-1 pull-right" onClick={login}>
                        <i className="fa fa-user-circle"></i>
                    </button>
                </div>
            </div>
        );
    }    
  }

  export default LoginButton;
  